import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api';
import {
  AnalyticsQueryParams,
  FetchCompaniesPaymentsFlowResponse,
  FetchPaymentsFlowResponse,
  FetchPurchasesFlowResponse,
} from './analytics.types';

export const getCompaniesPaymentsFlow = async ({
  params,
}: {
  params?: Omit<AnalyticsQueryParams, 'statuses'>;
}): Promise<AxiosResponse<FetchCompaniesPaymentsFlowResponse & ApiError>> => {
  return instance
    .get<FetchCompaniesPaymentsFlowResponse>('companies/analytics/payments', {
      params,
    })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

const paymentsFlowApiPath = (id: string) =>
  `companies/${id}/analytics/payments`;

export const getPaymentsFlow = async ({
  companyId,
  params,
}: {
  companyId: string;
  params?: Omit<AnalyticsQueryParams, 'statuses'>;
}): Promise<AxiosResponse<FetchPaymentsFlowResponse & ApiError>> => {
  return instance
    .get<FetchPaymentsFlowResponse>(paymentsFlowApiPath(companyId), { params })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};

const purchasesFlowApiPath = (id: string) =>
  `companies/${id}/analytics/purchases`;

export const getPurchasesFlow = async ({
  companyId,
  params,
}: {
  companyId: string;
  params?: Omit<AnalyticsQueryParams, 'aggregation'>;
}): Promise<AxiosResponse<FetchPurchasesFlowResponse & ApiError>> => {
  return instance
    .get<FetchPurchasesFlowResponse>(purchasesFlowApiPath(companyId), {
      params,
    })
    .catch((e) => e.response as AxiosError<ApiError> as never);
};
